import { Tag, Tooltip } from "antd";
import { paidOrderTagTitle } from "./JalaliDateCell";

const PaidOrderTag = ({ order }) => {
  const tooltip = paidOrderTagTitle(order);
  const tag = (
    <Tag color="green" style={{ margin: 0, fontWeight: 600 }}>
      {Number(order.payAmount).toLocaleString("en-US")}
    </Tag>
  );
  if (!tooltip) return tag;
  return (
    <Tooltip title={tooltip} mouseEnterDelay={0}>
      {tag}
    </Tooltip>
  );
};

export default PaidOrderTag;
